module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/329.5a33b599.png";